import { render, staticRenderFns } from "./FlexiLink.vue?vue&type=template&id=a590e75e&"
import script from "./FlexiLink.vue?vue&type=script&lang=js&"
export * from "./FlexiLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports